import { FC, useMemo } from 'react';
import { FormatterProps, ResourceData } from '../../../types';
import Button from 'shared/components/andtComponents/Button';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import { useGovernanceTagsProcessing } from '../../../hooks/useGovernanceTagsProcessing';

import styles from '../GovernanceTagsTableController.module.scss';

interface GovernanceTagActionFormatterProps extends FormatterProps {
  onEdit: (resource: ResourceData) => void;
}

const GovernanceTagActionFormatter: FC<GovernanceTagActionFormatterProps> = ({ row, onEdit }) => {
  const { isResourceProcessing } = useGovernanceTagsProcessing();
  const isProcessing = useMemo(() => {
    return row?.resourceId ? isResourceProcessing(row.resourceId) : false;
  }, [row?.resourceId, isResourceProcessing]);

  const { buttonText, iconName } = useMemo(() => {
    if (isProcessing) {
      return { buttonText: 'Processing tags may take few minutes. You can continue browsing', iconName: null };
    }

    const hasGovernanceTags = Array.isArray(row?.governanceTags) && row?.governanceTags.length > 0;
    const buttonText = hasGovernanceTags ? 'Edit Virtual Tag' : 'Add Virtual Tag';
    const iconName = hasGovernanceTags ? ICONS.pencil.name : ICONS.circlePlus.name;

    return { buttonText, iconName };
  }, [row?.governanceTags, isProcessing]);

  const handleClick = () => {
    if (row && onEdit && !isProcessing) {
      onEdit(row as ResourceData);
    }
  };

  if (isProcessing) {
    return <div className={styles.processingMessage}>{buttonText}</div>;
  }

  return (
    <Button
      text={buttonText}
      isTextButton
      automationid="governance-tag-action"
      icon={() => <GenerateIcon iconName={iconName} />}
      onClick={handleClick}
      className={styles.virtualTagActionButton}
    />
  );
};

export default GovernanceTagActionFormatter;
